export default __webpack_public_path__ + "static/media/favicon.6fb12bf9.ico";